import React from 'react';
import { useSelector } from 'react-redux';

import Throbber from '@r1-frontend/ui-react/components/loaders/Throbber';

import { selectServiceHelpFAQIsRedirected } from '~/src/features/faq/store/selectors';

import * as ST from './styled';

export interface IProps {
    text: string,
    title: string,
}

export const FAQArticle: React.FC<IProps> = ({ text, title }) => {
    const isLoading = useSelector(selectServiceHelpFAQIsRedirected);

    return (
        <ST.Wrap>
            {isLoading && <Throbber position={'absolute'}/>}
            <ST.ArticleTitle as='h1' $smaller>{title}</ST.ArticleTitle>
            <ST.DetailText
                dangerouslySetInnerHTML={{
                    __html: text,
                }}
            />
        </ST.Wrap>
    );
};
